<div class="content">
  <div class="right-side">
    <div class="box-content">
      <div class="header">
        <div class="logo"></div>
        <div class="app-name">
          <h1>{{ "project.nssf" | translate }}</h1>
          <p>{{ "project.sub_nssf" | translate }}</p>
        </div>
        <div class="main-title">
          <p>{{ "project.title" | translate }}</p>
          <div class="version">
            <h2>{{ "about_us.version" | translate }} {{ version }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="left-side">
    <div class="box-content">
      <div class="header">
        <h1 class="title mb-0">{{ "menu.register" | translate }}</h1>
        <p class="mt-2">{{ "menu.register_desc" | translate }}</p>
      </div>

      <form [formGroup]="form">
        <div class="row">
          <!-- Last / First Name KH -->
          <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "user.last_name_kh" | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="last_name_kh"
            />
          </div>

          <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "user.first_name_kh" | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="first_name_kh"
            />
          </div>

          <!-- Phone -->
          <div class="m-form col-xl-12 col-lg-12 col-md-12 mb-3">
            <label class="required" [class.required]="!optionals['phone']">{{
              "user.phone" | translate
            }}</label>
            <ngx-intl-tel-input
              appIntlOverlay
              formControlName="phone"
              [preferredCountries]="[CountryISO.Cambodia]"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name,
              ]"
              [phoneValidation]="isValidatePhone"
              [selectFirstCountry]="true"
              [searchCountryFlag]="true"
              [enableAutoCountrySelect]="true"
              inputId="phone-{{ uniqueIndex }}"
            ></ngx-intl-tel-input>
          </div>

          <!-- ID Card (for Khmer nationality) -->
          <div
            class="m-form col-xl-12 col-lg-12 col-md-12 mb-3"
            *ngIf="isKhmerNationality"
          >
            <label class="required">{{
              "member.form.label.card_number" | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="personal_code"
              maxlength="9"
            />
            <div
              *ngIf="
                form.get('personal_code')?.errors?.invalidLength &&
                form.get('personal_code')?.touched
              "
              class="text-danger small mt-1"
            >
              ID Card must be 9 digits.
            </div>
          </div>

          <!-- Email -->
          <div class="m-form col-xl-12 col-lg-12 col-md-12 mb-3">
            <label class="required">{{ "user.email" | translate }}</label>
            <input type="email" class="form-control" formControlName="email" />
          </div>

          <!-- Username -->
          <div class="m-form col-xl-12 col-lg-12 col-md-12 mb-3">
            <label class="required">{{ "user.username" | translate }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="username"
            />
          </div>

          <!-- Nationality -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{ "user.nationality" | translate }}</label>
            <app-select
              formControlName="nationality_id"
              [enableSearch]="true"
              (searchSubmit)="onNationalitySearchChange($event)"
            >
              <ng-container *ngIf="lang == LANG.KM; else natNameEng">
                <app-option
                  *ngFor="let nat of nationalities"
                  [value]="nat.nationality_id"
                >
                  {{ nat.nationality_kh }}
                </app-option>
              </ng-container>
              <ng-template #natNameEng>
                <app-option
                  *ngFor="let nat of nationalities"
                  [value]="nat.nationality_id"
                >
                  {{ nat.nationality_en }}
                </app-option>
              </ng-template>
            </app-select>
          </div> -->

          <!-- Passport (for non-Khmer nationality) -->
          <div
            class="m-form col-xl-12 col-lg-12 col-md-12 mb-3"
            *ngIf="!isKhmerNationality"
          >
            <label class="required">Passport Number</label>
            <input
              type="text"
              class="form-control"
              formControlName="passport"
            />
          </div>

          <!-- Issue Date -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "general.issue_date" | translate
            }}</label>
            <app-date-picker-locale
              formControlName="issue_date"
            ></app-date-picker-locale>
          </div> -->

          <!-- Expiry Date (readonly, auto-patched) -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "general.expiry_date" | translate
            }}</label>
            <app-date-picker-locale
              formControlName="expiry_date"
            ></app-date-picker-locale>
          </div> -->

          <!-- Last / First Name EN -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "user.last_name_en" | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="last_name_en"
            />
          </div>
          <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{
              "user.first_name_en" | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              formControlName="first_name_en"
            />
          </div> -->

          <!-- Gender -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{ "user.gender" | translate }}</label>
            <app-select formControlName="gender">
              <app-option [value]="GENDER.Male">{{
                "gender.M" | translate
              }}</app-option>
              <app-option [value]="GENDER.Female">{{
                "gender.F" | translate
              }}</app-option>
            </app-select>
          </div> -->

          <!-- Date of Birth -->
          <!-- <div class="m-form col-xl-6 col-lg-6 col-md-6">
            <label class="required">{{ "user.dob" | translate }}</label>
            <app-date-picker-locale
              formControlName="dob"
            ></app-date-picker-locale>
          </div> -->

          <!-- Password -->
          <div class="m-form col-xl-12 col-lg-12 col-md-12 mb-3">
            <div class="form-group-login col-md-12 pl px-0">
              <label class="required">{{ "user.password" | translate }}</label>
              <div class="m-form form-group mb-0 position-relative">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="password"
                  [class.is-invalid]="showPasswordMismatchError"
                />
                <button
                  type="button"
                  mat-icon-button
                  class="icon-suffix mat-button-reset"
                  (click)="showPassword = !showPassword"
                >
                  <mat-icon class="m-0 svg-icon">
                    {{ showPassword ? "visibility" : "visibility_off" }}
                  </mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="m-form col-xl-12 col-lg-12 col-md-12 mb-3">
            <div
              class="form-group-login col-md-12 pl px-0 position-relative"
              style="min-height: 75px"
            >
              <label class="required">{{
                "user.conf_password" | translate
              }}</label>
              <div class="m-form form-group mb-0 position-relative">
                <input
                  [type]="showConPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="con_password"
                  [class.is-invalid]="showPasswordMismatchError"
                />
                <button
                  type="button"
                  mat-icon-button
                  class="icon-suffix mat-button-reset"
                  (click)="showConPassword = !showConPassword"
                >
                  <mat-icon class="m-0 svg-icon">
                    {{ showConPassword ? "visibility" : "visibility_off" }}
                  </mat-icon>
                </button>
              </div>

              <div
                *ngIf="showPasswordMismatchError"
                class="invalid-feedback position-absolute w-100"
              >
                <p class="text-danger mb-0 small">Passwords do not match</p>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="d-flex justify-content-center mt-2">
        <div class="btn-container">
          <button
            routerLink=""
            type="button"
            mat-button
            class="m-button-outlined"
          >
            <mat-icon>output</mat-icon>{{ "button.back" | translate }}
          </button>
          <button
            type="button"
            (click)="onSubmit()"
            mat-raised-button
            class="m-button-primary"
          >
            <mat-icon>person_add</mat-icon
            >{{ "pms_child_code.REGISTER" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
